import React from "react";
import {
  Box,
  Card,
  CardContent,
  Typography,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Tooltip,
} from "@mui/material";

import InsightsIcon from "@mui/icons-material/Insights";
import ArrowRightAltIcon from "@mui/icons-material/ArrowRightAlt";

import AIIcon from "./AIIcon";
import DataSourceIcon from "../../Components/DataSourcesPanel";

const TalkingPointsCard = ({
  theme,
  topRisks,
  topOpps,
  entityId,
  AiSectionFeedback,
  requestId,
  uiSectionKey,
  userEmail,
}) => {
  return (
    <Card
      sx={{
        flex: 1.25,
        borderRadius: 3,
        boxShadow: "0 10px 25px rgba(15,23,42,0.10)",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <CardContent sx={{ p: 3, flexGrow: 1 }}>
        <Box sx={{ display: "flex", justifyContent: "space-between", mb: 1 }}>
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <InsightsIcon sx={{ color: theme.palette.primary.main }} />
            <Tooltip
              title="AI talking points to guide your next discussion."
              arrow
            >
              <Typography
                variant="h6"
                sx={{
                  fontWeight: 800,
                  fontSize: "1.05rem",
                  color: theme.palette.primary.main,
                  cursor: "help",
                }}
              >
                Talking Points
              </Typography>
            </Tooltip>
            <AIIcon />
            <DataSourceIcon mode="light" sources={["Salesforce Events"]} />
          </Box>

          <AiSectionFeedback
            sectionName="ClientEngagement - Talking Points (AI)"
            entityId={entityId}
            variant="light"
            requestId={requestId}
            uiSectionKey={uiSectionKey}
            userEmail={userEmail}
          />
        </Box>

        <Typography
          sx={{
            fontSize: "0.82rem",
            color: theme.palette.text.secondary,
            mb: 1.2,
          }}
        >
          Use these to structure your next stakeholder touchpoint.
        </Typography>

        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: { xs: "1fr", md: "1fr 1fr" },
            gap: 2,
          }}
        >
          <Box
            sx={{
              border: "1px solid #e5e7eb",
              borderRadius: 2,
              p: 1.5,
              bgcolor: "#fafafa",
            }}
          >
            <Typography sx={{ fontWeight: 800, fontSize: "0.85rem", mb: 0.6 }}>
              Risks to Address
            </Typography>
            {topRisks.length > 0 ? (
              <List dense>
                {topRisks.map((r, idx) => (
                  <ListItem key={idx} sx={{ py: 0.25 }}>
                    <ListItemIcon sx={{ minWidth: 26 }}>
                      <ArrowRightAltIcon
                        sx={{ color: theme.palette.primary.main, fontSize: 16 }}
                      />
                    </ListItemIcon>
                    <ListItemText
                      primary={r}
                      primaryTypographyProps={{ fontSize: "0.78rem" }}
                    />
                  </ListItem>
                ))}
              </List>
            ) : (
              <Typography sx={{ fontSize: "0.78rem", color: "#6b7280" }}>
                —
              </Typography>
            )}
          </Box>

          <Box
            sx={{
              border: "1px solid #e5e7eb",
              borderRadius: 2,
              p: 1.5,
              bgcolor: "#fafafa",
            }}
          >
            <Typography sx={{ fontWeight: 800, fontSize: "0.85rem", mb: 0.6 }}>
              Opportunities
            </Typography>
            {topOpps.length > 0 ? (
              <List dense>
                {topOpps.map((o, idx) => (
                  <ListItem key={idx} sx={{ py: 0.25 }}>
                    <ListItemIcon sx={{ minWidth: 26 }}>
                      <ArrowRightAltIcon
                        sx={{ color: theme.palette.primary.main, fontSize: 16 }}
                      />
                    </ListItemIcon>
                    <ListItemText
                      primary={o}
                      primaryTypographyProps={{ fontSize: "0.78rem" }}
                    />
                  </ListItem>
                ))}
              </List>
            ) : (
              <Typography sx={{ fontSize: "0.78rem", color: "#6b7280" }}>
                —
              </Typography>
            )}
          </Box>
        </Box>
      </CardContent>
    </Card>
  );
};

export default TalkingPointsCard;
